<template>
  <div class="assigned-list">
    <div
      v-if="histories.length > 0"
      class="assigned-list-title"
    >{{ $t('workPermit.assignedHistory') }}:</div>
    <ol>
      <li
        class="assigned-list-item"
        v-for="(item, index) in histories"
        :key="index"
      >{{ item }}</li>
    </ol>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import dateUtil, { DD_MMM_YY_HH_MM } from '@/utils/dateUtil'

export default {
  computed: {
    ...mapGetters('workPermit', ['currentWorkPermit']),
    histories () {
      const records = _.get(this.currentWorkPermit, 'histories', [])
      return records.filter(item => item.detail.isReassign).map(item => {
        const date = dateUtil.format(item.createdAt, DD_MMM_YY_HH_MM)
        return this.$t('action.assignedBy', [item.who.displayName, date])
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.assigned-list {
  margin-top: 15px;
  &-title {
    font-weight: bold;
  }
  &-title, &-item {
    color: #878787;
    font-size: 12px;
    font-style: italic;
    padding: 0;
  }
}
</style>
